import { jsx as _jsx } from "react/jsx-runtime";
import MuiGrid from '@mui/material/Grid';
import * as React from 'react';
import { Alert } from '../alert';
import { Box } from '../box';
import { flattenChildren } from '../utils';
export const GRID_CONFIG = {
    /**
     * Globally override the default sizes as container-queries for your application
     * @see packages/ml-rubiks-styleguide/.storybook/preview.tsx
     * @see packages/ml-webclient-rubiks/src/components/bootstrap/index.tsx
     */
    sizes: {
        '@0': -1
    }
};
export const Grid = (props) => {
    const { containerOffset = 0, loading } = props;
    const columnMaxWidth = typeof props.columnMaxWidth === 'number'
        ? `${props.columnMaxWidth}px`
        : props.columnMaxWidth;
    const children = (() => {
        if (loading) {
            const length = loading.count;
            return Array.from({ length }).map((_, i) => (_jsx(React.Fragment, { children: loading.component }, i)));
        }
        return Array.isArray(props.children)
            ? props.children
            : [props.children];
    })();
    React.useEffect(() => {
        if (GRID_CONFIG.sizes['@0'] === -1) {
            console.error('[Grid] `GRID_CONFIG.sizes` are not configured. Please set GRID_CONFIG.sizes in your application. (@see packages/ml-webclient-rubiks/src/components/bootstrap/index.tsx)');
        }
    }, []);
    if (props.error) {
        return _jsx(Alert, { severity: "error", children: props.error.message });
    }
    const gridColumns = {
        ...Object.entries(GRID_CONFIG.sizes).reduce((acc, [key, value], i, arr) => ({
            ...acc,
            [modifyContainerSize(key, containerOffset)]: `repeat(${value}, ${i === arr.length - 1 ? columnMaxWidth : '1fr'})`
        }), {})
    };
    return (_jsx(Box, { sx: { containerType: 'inline-size', width: '100%' }, children: _jsx(MuiGrid, { container: true, display: "grid", gridTemplateColumns: gridColumns, gap: 2, ...props.containerProps, children: flattenChildren(children).map((child, index) => (_jsx(MuiGrid, { maxWidth: columnMaxWidth, ...props.itemProps, children: child }, index))) }) }));
};
function modifyContainerSize(size, offset = 0) {
    const sizeNumber = Number(size.slice(1));
    const newSize = Math.max(0, sizeNumber + offset);
    return `@${newSize}`;
}
